import {dhtmlXCalendarObject,dhtmlXDoubleCalendar} from './dhtmlXCalendarObject';
import  './dhtmlXCalendarMethod';

export {dhtmlXCalendarObject,dhtmlXDoubleCalendar};



// WEBPACK FOOTER //
// ./goingsrc/dx/dxSource/components/dhtmlXCalendar/index.js